import { Icon } from "../../../components/Icon/Icon.tsx";
import { useFontFileDialog } from "../../../hooks/useFontFileDialog.ts";
import { useAppMutation } from "../../../http/useAppMutation.ts";
import { useWorkspace } from "../../hooks/useWorkspace.ts";
import { useWorkspaceFonts } from "../../hooks/useWorkspaceFonts.ts";
import { BrandDeletionButton } from "./components/BrandDeletionButton.tsx";
import { BrandKitSection } from "./components/BrandKitSection.tsx";

export const BrandFontSection = () => {
  const { workspace } = useWorkspace();

  const { mutate: createBrandFont, isLoading: isCreatingBrandFont } =
    useAppMutation({
      path: `workspaces/${workspace.uuid}/brand-fonts/`,
      invalidate: [`workspaces/${workspace.uuid}`],
      config: {
        headers: {
          Accept: "application/json",
          // Content-Type must be set to "multipart/form-data" for font file uploads.
          // This enables the browser to properly encode the FormData payload
          // which contains both binary font file data and text metadata (font family name).
          // The multipart encoding allows the server to parse mixed content types in a single request.
          // Without this header, the server would receive malformed data and fail to process the upload.
          "Content-Type": "multipart/form-data",
        },
      },
    }).mutation;

  const openFileBrowser = useFontFileDialog({
    onFontLoaded: (fontFamily, file) => {
      const formData = new FormData();
      formData.append("file", file as Blob);
      formData.append("name", fontFamily);
      createBrandFont(formData);
    },
  });

  const { workspaceFonts } = useWorkspaceFonts();

  return (
    <BrandKitSection
      title="Fonts"
      onAdd={openFileBrowser}
      isLoading={isCreatingBrandFont}
    >
      {workspaceFonts.length > 0 ? (
        <div className="flex-row items-center gap-400">
          {workspaceFonts.map((brand) => (
            <div
              key={brand.uuid}
              className="relative group flex-col-center gap-50 w-[150px]"
            >
              <div
                className="h-[40px] flex-col-center text-center body-lg-default"
                style={{ fontFamily: brand.family }}
              >
                AaBbCcDdEeFf
              </div>
              <div className="body-sm-default text-secondary text-center">
                {brand.family}
              </div>
              <div className="absolute right-0 top-0 invisible group-hover:visible">
                <BrandDeletionButton brandUuid={brand.uuid} />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex-col-center gap-400">
          <Icon name="Type" size="xl" />
          <div className="body-md-default text-secondary">
            Define your brand fonts to be able to use them from anywhere in the
            app.
          </div>
        </div>
      )}
    </BrandKitSection>
  );
};
